<div class="vtr-modal-license-agreement">
	<div class="section-header">
		<div role="text" class="header-text" aria-describedby="license-agreement-header-text" [innerHtml]="'license-agreement.header-text' | translate">
		</div>
	</div>

	<div class="section-body">
		<div class="checkbox-section">
			<ul>
				<li class="line-check-license">
					<vtr-material-checkbox
						[componentId]="'cb-accept-license-agreement'"
						[value]="checkedLicense"
						[checked]="checkedLicense"
						[hasChild]="true"
						(toggle)='onLicenseCheckedChange($event)'
					>
						<span [attr.dir]="textDirection"
							*vtrTranslate="'license-agreement.license-text' | translate">
							<a mat-customize-button class="link-button" href="#" role="link" id="license-agreement-link" (click)="onClickLicenseLink($event)" (keydown.enter)="onClickLicenseLink($event)"></a>
						</span>
					</vtr-material-checkbox></li>
				<li class="line-check-privacy">
					<vtr-material-checkbox
						[componentId]="'cb-accept-privacy'"
						[value]="checkedPrivacy"
						[checked]="checkedPrivacy"
						[hasChild]="true"
						(toggle)='onPrivacyCheckedChange($event)'
					>
						<span [attr.dir]="textDirection" *vtrTranslate="'license-agreement.privacy-text' | translate">
							<a mat-customize-button class="link-button" href="#" role="link" id="privacy-link" (click)="onClickPrivacyLink($event)" (keydown.enter)="onClickPrivacyLink($event)"></a>
						</span>
					</vtr-material-checkbox></li>
			</ul>
		</div>

		<div class="line-consent-buttons">
			<vtr-material-button
					(buttonClick)="onClickLetsGo()"
					(keydown.enter)="onClickLetsGo()"
					[isDisabled]="disableLetsGo"
					[label]="'license-agreement.lets-go' | translate"
					[linkId]="'license-agreement-lets-go'">
			</vtr-material-button>
			<button
				*ngIf="disableLetsGo"
				id="license-agreement-close"
				mat-customize-button
				class="link-button ml-4"
				(click)="onClickClose()"
				(keydown.enter)="onClickClose()"
			>{{'license-agreement.close-btn' | translate}}</button>
		</div>
	</div>
</div>
